import React from 'react';
import { abhaStatusMeta, abhaToneColors } from './abhaStatusMeta';
import useAbdmEnabled from '../../hooks/useAbdmEnabled';

/**
 * AbhaBadge — small solid status chip driven by the single-source abhaStatusMeta helper.
 * Shared by BookAppointmentForm and RegisterVisitForm so the ABHA status reads identically
 * everywhere (patient-select rows, appointment/visit cards).
 */
export default function AbhaBadge({ status, isDark }) {
  const { show } = useAbdmEnabled(); // org ABDM off: no ABHA UI anywhere
  if (!show) return null;
  const meta = abhaStatusMeta(status);
  const c = abhaToneColors(meta.tone, isDark);
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '0.25rem', flexShrink: 0,
      fontSize: '0.6875rem', fontWeight: 700, letterSpacing: '0.02em',
      padding: '0.15rem 0.5rem', borderRadius: '9999px',
      background: c.bg, color: c.text, border: `1px solid ${c.border}`,
    }}>{meta.icon ? `${meta.icon} ` : ''}{meta.label}</span>
  );
}
